"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunarObservationPost = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var ResourceType_1 = require("../../ResourceType");
var AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
var Units_1 = require("../../Units");
var MoonCard_1 = require("./MoonCard");
var LunarObservationPost = (function (_super) {
    __extends(LunarObservationPost, _super);
    function LunarObservationPost() {
        var _this = _super.call(this, {
            name: CardName_1.CardName.LUNAR_OBSERVATION_POST,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.SCIENCE],
            cost: 7,
            productionBox: Units_1.Units.of({}),
            resourceType: ResourceType_1.ResourceType.DATA,
            metadata: {
                description: 'Spend 1 titanium. 1 VP for every 3 data resources here.',
                cardNumber: 'M22',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Add 1 data resource to ANY card', function (ab) {
                        ab.data().startAction.asterix();
                    });
                    b.br;
                    b.minus().titanium(1);
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.data(1, 3),
            },
        }, {
            reserveUnits: Units_1.Units.of({ titanium: 1 }),
        }) || this;
        _this.resourceCount = 0;
        return _this;
    }
    LunarObservationPost.prototype.play = function (player) {
        _super.prototype.play.call(this, player);
        return undefined;
    };
    LunarObservationPost.prototype.canAct = function () {
        return true;
    };
    LunarObservationPost.prototype.action = function (player) {
        player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.DATA));
        return undefined;
    };
    LunarObservationPost.prototype.getVictoryPoints = function () {
        return Math.floor(this.resourceCount / 3);
    };
    return LunarObservationPost;
}(MoonCard_1.MoonCard));
exports.LunarObservationPost = LunarObservationPost;
//# sourceMappingURL=LunarObservationPost.js.map